import { AppAreaConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-walking-outdoor',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-outdoor-f', 'age-walking-outdoor-f'],
		route: {
			path: '/walking-outdoor-f',
			name: 'walking-outdoor-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-walking-outdoor',
		route: {
			path: '/walking-outdoor-f/ob/:page(.*)?',
			name: 'activity-female-walking-outdoor',
		},
		slug: 'activity-female-walking-outdoor',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-outdoor-f',
		overrides: [
			{
				matcher: { country: 'us' },
				routeName: 'plan-walking-outdoor-f-us',
			},
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-walking-outdoor-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
}

export default appAreaConfig
